import { useEffect } from "react";

const useKeyboardShortcut = (handlers) => {
    const { modifier, keyTrigger, handler } = handlers;
  useEffect(() => {
    const handleKeyDown = (event) => {
      const { ctrlKey, shiftKey, key } = event;
      if(modifier === "ctrl"){
        if (ctrlKey && key === keyTrigger && handler) {
          handler();
        }
      }
      if(modifier === "shift"){
        if (shiftKey && key === keyTrigger && handler) {
          handler();
        }
      }
      if(modifier === "alt"){
        if (event.altKey && key === keyTrigger && handler) {
          handler();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [modifier, keyTrigger, handler]);
};

export default useKeyboardShortcut;